import React from 'react';
import { Box } from '@mui/material';
import PageHeader from '../PageHeader';
import { IPD_COLORS } from '../../theme';

/** Standard layout for Store Management pages under Inventory. */
export default function StoreMasterShell({ title, description, badge, actions, children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, color: IPD_COLORS.textPrimary }}>
      <PageHeader
        eyebrow="Inventory Management"
        title={title}
        description={description}
        badge={badge}
        actions={actions}
      />
      {children}
    </Box>
  );
}
